import GraphNumericSurvey from "./GraphNumericSurvey";

export default GraphNumericSurvey;